const Smile = ({ size = 48 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48">
      <path
        d="M41.975 40.813a5.126 5.126 0 0 1-1.988-5.7l1.388-4.613c.225-.637.413-1.275.563-1.913l.112-.375c.038-.112.038-.187.038-.3.262-1.312.412-2.7.374-4.124-.15-10.463-8.7-18.675-19.2-18.413C13.175 5.638 5.075 13.85 5 24.012c-.075 10.463 8.625 18.863 19.05 18.863h17.325c.6 0 1.087-.45 1.125-1.087 0-.375-.188-.75-.525-.975Z"
        fill="#0055B8"
      />
      <path
        d="M30.012 26c.675 0 1.238.6 1.125 1.275A7.498 7.498 0 0 1 23.75 33.5a7.498 7.498 0 0 1-7.387-6.225C16.25 26.6 16.774 26 17.488 26h12.524ZM18.5 17a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm11.887 4.5H26.75a1.105 1.105 0 0 1-1.125-1.125c0-.637.488-1.125 1.125-1.125h3.637c.638 0 1.125.488 1.125 1.125s-.487 1.125-1.125 1.125Z"
        fill="#fff"
      />
    </svg>
  );
};

export default Smile;
